module.exports = __webpack_public_path__ + "img/84.d2a943fd.jpg";